import { RequestParameters } from '@tangilla/tg-ng-models';

const transformToFilter = (obj, optionsGroupLabel, isStringValue) => {
    if (obj && Object.values(obj)) {
        return {
            label: optionsGroupLabel,
            filterItems: Object.keys(obj).map(key => ({
                value: isStringValue ? obj[key].toString() : obj[key],
                label: isStringValue ? key.toString() : key
            }))
        };
    }
    return undefined;
};
const transformEnumToArray = (EnumObject, type, isStringValue) => {
    if (EnumObject && Object.values(EnumObject)) {
        return Object.keys(EnumObject).map(key => ({
            value: isStringValue ? EnumObject[key].toString() : EnumObject[key],
            label: isStringValue ? key.toString() : key,
            type,
        }));
    }
    return [];
};

class LayoutUtil {
    static elementHasScrollbar(htmlElement) {
        const scrollHeight = htmlElement?.scrollHeight;
        const clientHeight = htmlElement?.clientHeight;
        const hasScrollbar = !!scrollHeight && clientHeight && scrollHeight > clientHeight;
        return hasScrollbar;
    }
}

class StringUtils {
    static startsWithVowel(value) {
        if (value) {
            const vowelRegex = '^[aieouAIEOU].*';
            return value.match(vowelRegex);
        }
        return false;
    }
    static capitalize(value, multipleWords, onlyCapital) {
        if (value) {
            if (multipleWords) {
                const wordsToCapitalize = value.substring(0).split(/[\s_]+/);
                const capitalizedWords = StringUtils.capitalizeAllWords(wordsToCapitalize, onlyCapital).join(' ');
                return capitalizedWords;
            }
            return value[0].toUpperCase() + value.substr(1).toLowerCase();
        }
        return value;
    }
    static capitalizeAllWords(words, onlyCapital) {
        return words.map((word, index) => {
            if (index === 0) {
                if (word === 'sms') {
                    return 'SMS';
                }
            }
            return word.charAt(0).toUpperCase() + (onlyCapital ? word.slice(1).toLowerCase() : word.slice(1));
        });
    }
    static toMoney(value, fixedNumber = 2) {
        if (value || value === 0) {
            const valueSign = Math.sign(value);
            return `${valueSign === -1 ? '-' : ''}$${(Math.round((valueSign === -1 ? value * -1 : value) * 100) / 100).toFixed(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        }
        return value;
    }
}

class FiltersUtil {
    static getCurrentFilter(dropdownFilters, filter, search = '', limit = 20, offset = 0, orderBy, orderByDirection, additionalFields = {}) {
        const currentFilter = new RequestParameters(filter, search, limit, offset, orderBy, orderByDirection, additionalFields);
        if (dropdownFilters && dropdownFilters.length > 0) {
            dropdownFilters.forEach((dropdownFilter, index) => {
                const filter = dropdownFilter.optionGroup ? dropdownFilter.optionGroup : dropdownFilter.type;
                if (dropdownFilter && dropdownFilter.independentQueryParam) {
                    additionalFields[filter] = dropdownFilter.value;
                }
                else {
                    const filterString = `${filter}=${dropdownFilter.value}`;
                    currentFilter.filter = !currentFilter.filter ? `${filterString}` : `${currentFilter.filter},${filterString}`;
                }
            });
        }
        currentFilter.additionalFields = additionalFields;
        return currentFilter;
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { FiltersUtil, LayoutUtil, StringUtils, transformEnumToArray, transformToFilter };
